import React from 'react';

import LoadingButtonWrapper from '~/components/LoadingButtonWrapper';

interface LoadMoreButtonProps {
  loading: boolean;
  page: number;
  totalPages?: number;
  onNext: () => void;
  label: string;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  loading,
  onNext,
  page,
  totalPages = 0,
  label,
}) => {
  return (
    <LoadingButtonWrapper
      data-testid="load-more"
      color="primary"
      variant="outlined"
      size="small"
      onClick={onNext}
      disabled={page === totalPages}
      loading={loading}
    >
      {label}
    </LoadingButtonWrapper>
  );
};

export default LoadMoreButton;
